document.addEventListener('DOMContentLoaded', () => {
  const langSwitch = document.querySelector('.ed-header .language-switcher');
  const langSwitchActive = document.querySelector('.ed-header .language-switcher .active-lang');
  const dropdownItems = document.querySelectorAll('.ed-header .has-dropdown');
  const hamburger = document.querySelector('.ed-header .hamburger');
  const header = document.querySelector('.ed-header');
  const mobileMenu = document.querySelector('.ed-header .mobile-menu');
  const mobileMenuClose = document.querySelector('.ed-header .mobile-menu .close-mobile-menu');
  const searchTrigger = document.querySelector('.ed-header .mobile-buttons .searchicon');
  const mobileSearch = document.querySelector('.search-mobile');


  langSwitchActive.addEventListener('click', () => {
    langSwitch.classList.toggle('active');
  });

  document.addEventListener('click', (event) => {
    if (!langSwitch.contains(event.target) && langSwitch.classList.contains('active')) {
      langSwitch.classList.remove('active');
    }
  });

  if (document.body.classList.contains('home')) {
    header.querySelector('.logo').classList.add('big');

    header.addEventListener('mouseenter', () => {
      if (window.scrollY === 0) {
        header.classList.remove('transparent');
      }
    });

    header.addEventListener('mouseleave', () => {
      if (window.scrollY === 0 && !mobileMenu.classList.contains('active')) {
        header.classList.add('transparent');
      }
    });
  }

  document.addEventListener('click', (event) => {
    if (mobileMenu.classList.contains('active') && !mobileMenu.contains(event.target) && !hamburger.contains(event.target)) {
      hamburger.classList.remove('open');
      mobileMenu.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }
  });

  mobileMenuClose.addEventListener('click', () => {
    hamburger.classList.remove('open');
    mobileMenu.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  });

  document.addEventListener('click', (event) => {
    if (mobileMenu.classList.contains('active') && !mobileMenu.contains(event.target) && !hamburger.contains(event.target)) {
      hamburger.classList.remove('open');
      mobileMenu.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }
  });

  mobileMenuClose.addEventListener('click', () => {
    hamburger.classList.remove('open');
    mobileMenu.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  });

  hamburger.addEventListener('click', () => {
    document.body.classList.toggle('overflow-hidden');
    document.body.classList.toggle('overflow-hidden');
    hamburger.classList.toggle('open');
    mobileMenu.classList.toggle('active');
  });

  searchTrigger.addEventListener('click', (event) => {
    event.stopPropagation();
    searchTrigger.classList.toggle('active');
    mobileMenu.classList.add('active');
    document.body.classList.add('overflow-hidden');
    mobileSearch.querySelector('input').focus();
    mobileSearch.classList.toggle('active');
    header.classList.add('searching');
  });

  function updateDropdownPosition(dropdownItem, dropdown) {
    const rect = dropdownItem.getBoundingClientRect();
    dropdown.style.top = `${rect.bottom}px`;
  }

  function checkScroll() {

    if (document.body.classList.contains('home')) {

      if (window.scrollY > 0) {
        header.classList.remove('transparent');
        header.querySelector('.logo').classList.remove('big');
      } else if (!mobileMenu.classList.contains('active')) {
        header.classList.add('transparent');
      }

      if(document.querySelector('.ed-header .dropdown.active')) {
        header.classList.remove('transparent');
      }

      hamburger.addEventListener('click', () => {
        if (window.scrollY === 0) {
          if (mobileMenu.classList.contains('active')) {
            header.classList.remove('transparent');
          } else {
            header.classList.add('transparent');
          }
        }
      });
    }
  }

  checkScroll();

  dropdownItems.forEach(dropdownItem => {
    const dropdown = dropdownItem.querySelector('.dropdown');

    dropdownItem.addEventListener('mouseenter', () => {
      header.classList.remove('transparent');
      updateDropdownPosition(dropdownItem, dropdown);
      dropdown.style.display = 'block';
      dropdown.classList.add('active');
    });

    dropdownItem.addEventListener('mouseleave', () => {
      dropdown.style.display = 'none';
      dropdown.classList.remove('active');
    });

    window.addEventListener('scroll', () => {
      if (dropdown.style.display === 'block') {
        updateDropdownPosition(dropdownItem, dropdown);
      }
    });

    window.addEventListener('resize', () => {
      if (dropdown.style.display === 'block') {
        updateDropdownPosition(dropdownItem, dropdown);
      }
    });
  });

  window.addEventListener('scroll', () => {
    checkScroll();
    if (document.body.classList.contains('home')) {
    }
  });

  window.addEventListener('resize', () => {
    if (document.body.classList.contains('home')) {
    }
  });
});